import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { CurrentUser } from 'api/currentUser';
import { RouterLink } from 'components/Link';

const getPath = ({ orgs, groups }: CurrentUser) => {
  if (orgs && groups) {
    if (orgs.length === 1 && groups.length === 0) {
      const org = orgs[0];

      if (org.isAllowedToPost && !org.isFrozen) {
        return `/admin/${org.id}/post-a-listing`;
      }

      return `/admin/${org.id}`;
    }

    if (orgs.length === 0 && groups.length === 1) {
      const group = groups[0];

      if (group.isApproved && !group.isFrozen) {
        return `/group-admin/${group.id}/volops/create`;
      }

      return `/group-admin/${group.id}`;
    }
  }

  return '/post-a-listing';
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const PostListingLink = ({
  children,
  className,
  component,
  'data-qa-id': qaId,
  onClick,
}: {
  children?: ReactNode;
  className?: string;
  component?: React.ComponentType<{
    children: ReactNode;
    onClick?: () => void;
    to:
      | {
          pathname: string;
          state: {
            from: string;
          };
        }
      | string;
    from?: string;
    'data-qa-id'?: string;
  }>;
  onClick?: () => void;
  'data-qa-id'?: string;
}) => {
  const { currentUser } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
    currentUser: state.currentUser,
  }));
  const location = useLocation();
  const Component = component || RouterLink;
  const pathname = getPath(currentUser);
  return (
    <Component
      className={className}
      to={{
        pathname,
        state: {
          from: location.pathname,
        },
      }}
      from={location.pathname}
      data-qa-id={qaId || 'post-a-listing'}
      onClick={onClick}
    >
      {children || getText('Post a Listing')}
    </Component>
  );
};

// eslint-disable-next-line import/no-default-export
export default PostListingLink;
